import type { Attachment } from 'modules/attachments/types';
import type { EmbeddedEnterprise, EmbeddedUser } from 'modules/core/types';

export type TicketCategory = 'ADD_COMPANY' | 'ADD_OUTLET_OR_SERVICE_CATEGORY' | 'ADD_CLIENT';
export const ticketStates = ['OPEN', 'CLOSED', 'CANCELED'] as const;
export type TicketState = (typeof ticketStates)[number];

export type Ticket = {
  id: number;
  category: TicketCategory;
  state: TicketState;
  enterprise: EmbeddedEnterprise;
  title: string;
  body: string;
  author: EmbeddedUser;
  assignee?: EmbeddedUser;
  created_at: string;
  closed_at: string | null;
  data: Record<string, any> | null;
  attachments: Attachment[];
};
